export default "__VITE_ASSET__BhsUGzAJ__"